import * as Yup from 'yup';

export const validationSchema = Yup.object({
  name: Yup.string().max(250, 'Must be less than 250 characters').required('Task name is required'),
  notes: Yup.string().max(1000, 'Must be less than 1000 characters').nullable().defined(),
  lead: Yup.mixed().required('Lead is required').nonNullable().notOneOf([0], 'Lead is required'),
  vendor: Yup.mixed().nullable().defined(),
  support: Yup.mixed().nullable().defined(),
  startDate: Yup.string().nullable().defined(),
  dueDate: Yup.string().nullable().defined(),
});
